export default () => {
	try {
		return new Date().toLocaleTimeString('en-us',{timeZoneName:'short'}).split(' ')[2]
	} catch (e) {
		return null
	}
}



// WEBPACK FOOTER //
// ./src/utilities/localTimeZoneAbbrev.js